import { getRegionMapAreas } from '../coordinates';

export const getRhoneData = () => ({
  name: "Rhône",
  country: "France",
  description: "La Vallée du Rhône s'étend sur 200 km du nord au sud de la France, produisant des vins rouges puissants et des vins blancs aromatiques. Cette région se divise en deux zones distinctes : les Côtes du Rhône septentrionales et méridionales, chacune avec ses caractéristiques propres.",
  type: "region",
  mapAreas: getRegionMapAreas("Rhône"),
  statistics: {
    totalArea: "80,000 ha",
    production: "2.8 million hectolitres",
    appellations: "31 appellations",
    departments: "6 départements",
    exportPercentage: "35%"
  },
  characteristics: {
    climate: "Climat méditerranéen au sud, continental au nord",
    soil: "Sols de granit au nord, galets roulés et argile au sud",
    viticulture: "Viticulture traditionnelle, rendements limités, vins de terroir"
  },
  wineStyles: {
    red: "Vins rouges puissants et structurés, du fruité au tannique",
    white: "Vins blancs aromatiques et complexes",
    rose: "Rosés fruités et équilibrés",
    sweet: "Vins doux naturels, concentrés et complexes"
  },
  history: "La viticulture dans la Vallée du Rhône remonte à l'époque romaine. Au Moyen Âge, les papes d'Avignon ont développé la viticulture. Le XIXe siècle a vu l'émergence des appellations. Aujourd'hui, la Vallée du Rhône est reconnue pour ses vins de qualité.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine provençale",
  subregions: {
    "cote-rotie": {
      name: "Côte-Rôtie",
      description: "Appellation prestigieuse du Rhône septentrional, produisant des vins rouges élégants et complexes.",
      characteristics: {
        climate: "Climat continental avec influence méditerranéenne",
        soil: "Sols de granit, schiste et micaschiste",
        viticulture: "Viticulture en terrasses, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Syrah", "Viognier"]
      },
      wineStyles: {
        red: "Vins rouges élégants et complexes"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés"
    },
    "condrieu": {
      name: "Condrieu",
      description: "Appellation phare des vins blancs du Rhône septentrional, exclusivement Viognier.",
      characteristics: {
        climate: "Climat continental avec influence méditerranéenne",
        soil: "Sols de granit, schiste et micaschiste",
        viticulture: "Viticulture en terrasses, vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Viognier"]
      },
      wineStyles: {
        white: "Vins blancs aromatiques et complexes"
      },
      foodPairing: "Poissons, fruits de mer, volailles"
    },
    "hermitage": {
      name: "Hermitage",
      description: "Appellation prestigieuse du Rhône septentrional, vins rouges puissants et blancs complexes.",
      characteristics: {
        climate: "Climat continental avec influence méditerranéenne",
        soil: "Sols de granit, schiste et micaschiste",
        viticulture: "Viticulture en terrasses, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Syrah"],
        white: ["Marsanne", "Roussanne"]
      },
      wineStyles: {
        red: "Vins rouges puissants et structurés",
        white: "Vins blancs complexes et riches"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés"
    },
    "saint-joseph": {
      name: "Saint-Joseph",
      description: "Appellation importante du Rhône septentrional, vins rouges élégants et blancs aromatiques.",
      characteristics: {
        climate: "Climat continental avec influence méditerranéenne",
        soil: "Sols de granit, schiste et micaschiste",
        viticulture: "Viticulture en terrasses, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Syrah"],
        white: ["Marsanne", "Roussanne"]
      },
      wineStyles: {
        red: "Vins rouges élégants et équilibrés",
        white: "Vins blancs aromatiques et complexes"
      },
      foodPairing: "Viandes rouges, volailles, fromages affinés"
    },
    "cornas": {
      name: "Cornas",
      description: "Appellation prestigieuse du Rhône septentrional, exclusivement vins rouges puissants.",
      characteristics: {
        climate: "Climat continental avec influence méditerranéenne",
        soil: "Sols de granit, schiste et micaschiste",
        viticulture: "Viticulture en terrasses, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Syrah"]
      },
      wineStyles: {
        red: "Vins rouges puissants et structurés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés"
    },
    "chateauneuf-du-pape": {
      name: "Châteauneuf-du-Pape",
      description: "Appellation la plus prestigieuse du Rhône méridional, vins rouges puissants et complexes.",
      characteristics: {
        climate: "Climat méditerranéen chaud et sec",
        soil: "Sols de galets roulés, argile et calcaire",
        viticulture: "Viticulture traditionnelle, galets roulés caractéristiques"
      },
      grapeVarieties: {
        red: ["Grenache", "Syrah", "Mourvèdre", "Cinsault"],
        white: ["Grenache Blanc", "Clairette", "Bourboulenc"]
      },
      wineStyles: {
        red: "Vins rouges puissants et complexes",
        white: "Vins blancs riches et aromatiques"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés"
    },
    "gigondas": {
      name: "Gigondas",
      description: "Appellation prestigieuse du Rhône méridional, vins rouges puissants et structurés.",
      characteristics: {
        climate: "Climat méditerranéen chaud et sec",
        soil: "Sols de calcaire, argile et galets roulés",
        viticulture: "Viticulture en terrasses, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Grenache", "Syrah", "Mourvèdre", "Cinsault"]
      },
      wineStyles: {
        red: "Vins rouges puissants et structurés",
        rose: "Rosés fruités et équilibrés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés"
    },
    "vacqueyras": {
      name: "Vacqueyras",
      description: "Appellation prestigieuse du Rhône méridional, vins rouges puissants et blancs aromatiques.",
      characteristics: {
        climate: "Climat méditerranéen chaud et sec",
        soil: "Sols de calcaire, argile et galets roulés",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Grenache", "Syrah", "Mourvèdre", "Cinsault"],
        white: ["Grenache Blanc", "Clairette", "Roussanne"]
      },
      wineStyles: {
        red: "Vins rouges puissants et équilibrés",
        white: "Vins blancs aromatiques et complexes",
        rose: "Rosés fruités et équilibrés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés"
    },
    "ventoux": {
      name: "Ventoux",
      description: "Région du Mont Ventoux produisant des vins rouges, blancs et rosés de qualité.",
      characteristics: {
        climate: "Climat méditerranéen avec influence montagneuse",
        soil: "Sols de calcaire, argile et sable",
        viticulture: "Viticulture en altitude, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Grenache", "Syrah", "Carignan", "Cinsault"],
        white: ["Grenache Blanc", "Clairette", "Roussanne"]
      },
      wineStyles: {
        red: "Vins rouges fruités et équilibrés",
        white: "Vins blancs frais et aromatiques",
        rose: "Rosés frais et fruités"
      },
      foodPairing: "Viandes blanches, poissons, fromages"
    },
    "luberon": {
      name: "Luberon",
      description: "Région du Luberon produisant des vins rouges, blancs et rosés de qualité.",
      characteristics: {
        climate: "Climat méditerranéen tempéré",
        soil: "Sols de calcaire, argile et sable",
        viticulture: "Viticulture traditionnelle, respect de l'environnement"
      },
      grapeVarieties: {
        red: ["Grenache", "Syrah", "Carignan", "Cinsault"],
        white: ["Grenache Blanc", "Clairette", "Roussanne"]
      },
      wineStyles: {
        red: "Vins rouges fruités et élégants",
        white: "Vins blancs frais et aromatiques",
        rose: "Rosés frais et fruités"
      },
      foodPairing: "Viandes blanches, poissons, fromages"
    }
  }
}); 